import { FormFieldRowValue } from './form-field-row.type';

/** Per-field "missing required value" flags for a custom-field draft. */
export interface FormFieldRowErrors {
  name: boolean;
  min: boolean;
  max: boolean;
}

export const EMPTY_FORM_FIELD_ROW_ERRORS: FormFieldRowErrors = { name: false, min: false, max: false };

/**
 * Required-field validation for the custom-field editor, shared by the desktop inline editor and the
 * mobile modal so both flag the same fields: name is always required; a numeric field also needs Min and
 * Max, and Min must not exceed Max (an inverted range flags both inputs).
 */
export const getFormFieldRowErrors = (value: FormFieldRowValue): FormFieldRowErrors => {
  const name = value.name.trim() === '';
  if (value.type !== 'number') return { name, min: false, max: false };

  const minEmpty = value.min.trim() === '';
  const maxEmpty = value.max.trim() === '';
  const inverted = !minEmpty && !maxEmpty && Number(value.min) > Number(value.max);
  return { name, min: minEmpty || inverted, max: maxEmpty || inverted };
};

export const hasFormFieldRowErrors = (errors: FormFieldRowErrors): boolean => errors.name || errors.min || errors.max;
